import React from 'react';
import { Stack } from '@mui/material';

import BetaChip from '../utils/BetaChip';

// Header of the Studio column in the Forms list: the column name followed by the Beta chip.
// The column must stay unsortable so the chip is never wrapped in the sort button.
// See chips.md 7.28.
const FormStudioColumnLabel = () => (
  <Stack direction="row" alignItems="center" gap={1} component="span">
    Studio
    <BetaChip service="Form Studio" />
  </Stack>
);

export default FormStudioColumnLabel;
